import { createStore } from "zustand/vanilla";
const LIST_PANE_MIN = 240;
const LIST_PANE_MAX = 400;
const LIST_PANE_DEFAULT = 264;
const SHELL_STORAGE_KEY = "bf.shell";
const clampListPaneWidth = (width) => Math.round(Math.min(LIST_PANE_MAX, Math.max(LIST_PANE_MIN, width)));
function load(storage) {
  try {
    const raw = storage?.getItem(SHELL_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}
function createShellStore(storage) {
  const saved = load(storage);
  const store = createStore()((set) => ({
    listPaneWidth: typeof saved.listPaneWidth === "number" ? clampListPaneWidth(saved.listPaneWidth) : LIST_PANE_DEFAULT,
    listPaneCollapsed: saved.listPaneCollapsed === true,
    listDrawerOpen: false,
    density: saved.density === "compact" ? "compact" : "comfortable",
    setListPaneWidth: (width) => {
      set({ listPaneWidth: clampListPaneWidth(width) });
    },
    setListPaneCollapsed: (collapsed) => {
      set({ listPaneCollapsed: collapsed });
    },
    setListDrawerOpen: (open) => {
      set({ listDrawerOpen: open });
    },
    setDensity: (density) => {
      set({ density });
    }
  }));
  store.subscribe((s) => {
    try {
      storage?.setItem(
        SHELL_STORAGE_KEY,
        JSON.stringify({
          listPaneWidth: s.listPaneWidth,
          listPaneCollapsed: s.listPaneCollapsed,
          density: s.density
        })
      );
    } catch {
    }
  });
  return store;
}
export {
  LIST_PANE_DEFAULT,
  LIST_PANE_MAX,
  LIST_PANE_MIN,
  SHELL_STORAGE_KEY,
  clampListPaneWidth,
  createShellStore
};
//# sourceMappingURL=shell-store.js.map